(function(window, document, $) {
	"use strict";
	var postsFilter = {
		init: function() {
			var $filter = $('.filter');
			this.$selects = $('.selectContainer select');
			this.$spinner = $('.spinner');
			this.$items = $('.items');
			this.postType = $filter.data('postType');
			this.postTypeParam = $filter.data('postTypeParam');
			this.$paginationWrapper = $('.paginationWrapper');
			this.$postsCount = $('.filter-posts-count__count');
			this.path = '/wp-json/filter/get';

			this.bindEvents();
		},
		bindEvents: function() {
			var pathNameParts = window.location.pathname.split('/');

			pathNameParts = pathNameParts.filter(function(part) {
				return part.length > 0;
			});

			var pageUrl = '/' + pathNameParts[0] + '?';

			this.$selects.on('change', function() {
				var queryParams = {};
				queryParams[this.postTypeParam] = this.postType;

				this.$selects.each(function() {
					var value = $(this).val();
					if ($.trim(value).length > 0) {
						queryParams[$(this).data('param')] = value;
					}
				});

				var url = pageUrl + $.map(queryParams, function(value, key) {
						if (key != this.postTypeParam) {
							return key + '=' + value;
						}
						return '';
					}.bind(this)).filter(Boolean).join('&');

				window.history.replaceState(null, '', url);

				this.$spinner.show();

				$.get(this.path, queryParams, function(response) {
					this.$items.html($(response.posts));
					this.$paginationWrapper.html($(response.pagination));
					this.$postsCount.text(response.postsCount);
				}.bind(this)).always(function() {
					this.$spinner.hide();
				}.bind(this));
			}.bind(this));
		}
	};
	$(document).ready( function(){
		postsFilter.init();
	});
})(window, document, jQuery);

